import { render, staticRenderFns } from "./LensTags.vue?vue&type=template&id=27b3511f&scoped=true"
import script from "./LensTags.vue?vue&type=script&lang=js"
export * from "./LensTags.vue?vue&type=script&lang=js"
import style0 from "./LensTags.vue?vue&type=style&index=0&id=27b3511f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b3511f",
  null
  
)

export default component.exports